/**
 * ColorThemeService is a service that manages color themes for the application.
 * It provides methods to get and set the current color theme, and to initialize the color theme.
 */
class ColorThemeService {
    /**
     * Constructs the ColorThemeService.
     * @param {Object} $bridges - The bridges service.
     * @param {Object} $rootScope - The root scope service.
     * @param {Function} filterFilter - The filter filter function.
     * @param {Object} $translate - The translate service.
     * @param {Object} $injector - The injector service.
     */
    constructor($bridges, $rootScope, filterFilter, $translate, $injector) {
        this._logIdentifier = 'ColorThemeService';
        this.$logger = $bridges.logger();
        this._currentColorTheme = '00';
        this._colorThemes = [
            {
                index: '00',
                class: 'color-theme-default',
                name: "COLOR-THEME.DEFAULT"
            },
            {
                index: 'blackTextOnLightYellow',
                class: 'color-theme-01',
                name: "COLOR-THEME.LIGHT-YELLOW",
                bgColor: 'FAFAC8',
                color: '000000'
            },
            {
                index: 'blackTextOnBlue',
                class: 'color-theme-02',
                name: "COLOR-THEME.BLUE",
                bgColor: 'E6FFFF',
                color: '000000'
            },
            {
                index: 'blackTextOnYellow',
                class: 'color-theme-03',
                name: "COLOR-THEME.YELLOW",
                bgColor: 'FFFF00',
                color: '000000',
                highlightColor: '00ff04'
            },
            {
                index: 'blackTextOnPink',
                class: 'color-theme-04',
                name: "COLOR-THEME.PINK",
                bgColor: 'FFEEFA',
                color: '000000'
            },
            {
                index: 'blackTextOnGrey',
                class: 'color-theme-05',
                name: "COLOR-THEME.GREY",
                bgColor: 'E0DEDF',
                color: '000000'
            },
            {
                index: 'blackTextOnOffWhite',
                class: 'color-theme-06',
                name: "COLOR-THEME.OFF-WHITE",
                bgColor: 'FFFFE5',
                color: '000000'
            },
            {
                index: 'yellowTextOnBlack',
                class: 'color-theme-07',
                name: "COLOR-THEME.BLACK",
                bgColor: '000000',
                color: 'FFFF00',
                highlightColor: '6d6e71'
            }
        ];

        this.$logger.info(this, 'initialize');        
        this.$filterFilter = filterFilter;
        this.$rootScope = $rootScope;
        this.$injector = $injector;
        this.initColorTheme();
    }

    /**
     * Returns the available color themes.
     * @returns {Array} - The array of color themes.
     */
    getColorThemes() {
        return this._colorThemes;
    }

    /**
     * Returns the current color theme.
     * @returns {string} - The current color theme index.
     */
    getCurrentColorTheme() {
        return this._currentColorTheme;
    }

    /**
     * Sets the current color theme.
     * @param {string} val - The new color theme index.
     */
    setCurrentColorTheme(val) {
        console.log('ColorThemeService.setCurrentColorTheme', val);
        const IAAPreferencesService = this.$injector.get('IAAPreferencesService');
        const _iaaPreferences = IAAPreferencesService.getPreferences();
        if (_iaaPreferences.colorTheme !== val) {
            for (let i in window.CKEDITOR.instances) {
                const elem = window.CKEDITOR.instances[i],
                    ct = this.getColorThemes();
                for (let j in ct) {
                    try {
                        if (ct[j].index === val) {
                            $('body', elem.document.$).toggleClass(ct[j].class, true);
                        } else if (typeof _iaaPreferences.colorTheme !== "undefined" && ct[j].index === _iaaPreferences.colorTheme) {
                            $('body', elem.document.$).toggleClass(ct[j].class, false);
                        }
                    } catch (e) { }
                }
            }
            _iaaPreferences.colorTheme = val;
        }
        this._currentColorTheme = val;
        this.$rootScope.currentColorThemeObj = this.$filterFilter(this._colorThemes, { index: this._currentColorTheme })[0];
    }

    /**
     * Initializes the color theme.
     */
    initColorTheme() {
        this.$rootScope.currentColorThemeObj = this.$filterFilter(this._colorThemes, { index: this._currentColorTheme })[0];
    }
}

export default ColorThemeService;